import {
    Car, Home, Plane, HeartPulse, Scale,
    Landmark, Wallet, KeyRound, TrendingUp,
    PiggyBank, Truck, GraduationCap, Sprout,
} from "lucide-react";

const insurance = [
    { icon: Car, title: "RCA / CASCO", desc: "Oferte de la toți asigurătorii din piață, comparate într-un singur loc." },
    { icon: Home, title: "Locuință", desc: "PAD, facultativă, bunuri și răspundere civilă față de terți." },
    { icon: Plane, title: "Călătorii", desc: "Medicală, storno, sport, business." },
    { icon: HeartPulse, title: "Sănătate & Viață", desc: "Protecție medicală, life, accidente." },
    { icon: Scale, title: "Răspundere civilă", desc: "Profesională, generală, persoane fizice." },
];

const financial = [
    { icon: Landmark, title: "Credite ipotecare", desc: "Pentru achiziția unei case." },
    { icon: Wallet, title: "Credite imobiliare", desc: "Investiții și proprietăți comerciale." },
    { icon: KeyRound, title: "Nevoi personale", desc: "Cu sau fără garanție, dobândă fixă." },
    { icon: Home, title: "Noua Casă", desc: "Programul guvernamental, sub 5%." },
    { icon: TrendingUp, title: "Investiții", desc: "Soluții fiscal avantajoase pe termen lung." },
    { icon: PiggyBank, title: "Economisire", desc: "Depozite și planuri de acumulare." },
    { icon: Truck, title: "Leasing", desc: "Auto, utilaje, echipamente PFA și firme." },
    { icon: GraduationCap, title: "Studii", desc: "Finanțare pentru educație și burse." },
    { icon: Sprout, title: "Pensii private", desc: "Pilon II și III, cu deducere fiscală." },
];

function Card({ Icon, title, desc, onClick, testid }) {
    return (
        <button
            onClick={onClick}
            data-testid={testid}
            className="group text-left w-full bg-[#fcfbf8] border border-[#0d3d2e]/15 rounded-xl p-6 hover:border-[#0d3d2e]/40 hover:translate-y-[-2px] transition-all"
        >
            <div className="h-10 w-10 rounded-md bg-[#0d3d2e]/5 flex items-center justify-center text-[#0d3d2e] mb-5">
                <Icon className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <h3 className="font-display text-2xl text-[#0d3d2e] mb-1">{title}</h3>
            <p className="text-sm text-[#1a1a1a]/65">{desc}</p>
        </button>
    );
}

export default function Services({ onSelect }) {
    return (
        <section id="servicii" data-testid="services-section" className="bg-[#fcfbf8] py-24 lg:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-14">
                    <div className="lg:col-span-5">
                        <div className="text-xs uppercase tracking-[0.2em] text-[#0d3d2e]/60 mb-4">
                            01 — Servicii
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0d3d2e] leading-[1.05]">
                            Toate produsele financiare,<br />
                            <em className="not-italic text-[#0d3d2e]/70">într-un singur loc.</em>
                        </h2>
                    </div>
                <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                    <p className="text-base lg:text-lg text-[#1a1a1a]/70">
                        Lucrăm cu peste 20 de companii de asigurări, bănci și IFN-uri.
                        Tu ne spui ce ai nevoie, noi comparăm piața și îți recomandăm
                        soluția cea mai potrivită — gratuit, fără obligații.
                    </p>
                </div>
                </div>

                {/* Insurance row */}
                <div className="mb-16">
                    <div className="flex items-baseline justify-between mb-6">
                        <h3 className="font-display text-3xl text-[#0d3d2e]">Asigurări</h3>
                        <span className="text-xs uppercase tracking-[0.18em] text-[#0d3d2e]/50">5 categorii</span>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                        {insurance.map((s) => (
                            <Card
                                key={s.title}
                                Icon={s.icon}
                                title={s.title}
                                desc={s.desc}
                                onClick={() => onSelect?.(s.title)}
                                testid={`service-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                            />
                        ))}
                    </div>
                </div>

                {/* Financial bento */}
                <div>
                    <div className="flex items-baseline justify-between mb-6">
                        <h3 className="font-display text-3xl text-[#0d3d2e]">Credite & Financiar</h3>
                        <span className="text-xs uppercase tracking-[0.18em] text-[#0d3d2e]/50">9 categorii</span>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {/* Featured image card */}
                        <div className="relative rounded-xl overflow-hidden min-h-[260px] lg:row-span-2 lg:col-span-1 grain-overlay">
                            <img
                                src="/images/credits-featured.webp"
                                alt="Consultanță financiară OPTIM SAFE"
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-b from-[#0d3d2e]/20 via-[#0d3d2e]/50 to-[#0d3d2e]/95" />
                            <div className="relative h-full p-6 flex flex-col justify-end text-[#fcfbf8]">
                                <div className="font-display text-3xl leading-tight">
                                    Soluții financiare<br />pentru fiecare etapă din viață.
                                </div>
                            </div>
                        </div>

                        {financial.map((s) => (
                            <Card
                                key={s.title}
                                Icon={s.icon}
                                title={s.title}
                                desc={s.desc}
                                onClick={() => onSelect?.(s.title)}
                                testid={`service-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
